import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { ENDPOINT_UFS } from './constants';

export function useUfService() {
  const { backendGet } = Sebrae.useBackend();

  const recoverUfs = React.useCallback(
    () => backendGet(`${ENDPOINT_UFS}`),
    [backendGet],
  );

  return {
    recoverUfs,
  };
}
